(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["__LR__ui-post-message-app"] = factory();
	else
		root["__LR__ui-post-message-app"] = factory();
})(self, () => {
return 